import moment from "moment";
import { isWeb } from "./platform";
import { Language } from "../constants/options";
import { memberPortalUrl } from "../constants/settings";

export const IsDesktop = isWeb ? window.innerWidth > 1536 : false;
export const IsMiniDesktop = isWeb ? window.innerWidth >= 768 : false;

export const GetLangLabel = (lang: Language) => {
  switch (lang) {
    case Language.ENGLISH: return "ENG";
    case Language.ZH_CN: return "中";
  }
};
export const GetLangKey = () => {
  if(isWeb && localStorage.LANG) return localStorage.LANG;
  return Language.ENGLISH;
}
// Time
export const CNDateTimeFormat = "YYYY-MM-DD HH:mm";
export const CNDateFormat = "YYYY-MM-DD";
export const AUDateTimeFormat = "DD/MM/YYYY hh:mm A";
export const AUTimeFormat = "hh:mm A";
export const AUDDateFormat = "DD/MM/YYYY";
export const AUDTimeFormat = "hh:mm A";
export const AUStrDateTimeFormat = "DD MMM YYYY HH:mm A";
export const AUStrFullDateTimeFormat = "ddd, DD MMM YYYY HH:mm A";
export const AUStrDateFormat = "DD MMM YYYY";
export const AUStrDateNonYearFormat = "ddd, DD MMM";
export const AUStrDateTimeNonYearFormat = "DD MMM HH:mm A";

export const ProcessTimeStr = (time: string) => {
  return `${moment(time).isSame(moment(), 'day') ? `Today ${moment(time).format(AUDTimeFormat)}` : moment(time).format(AUDateTimeFormat)}`;
};

export const AlphabetList: string[] = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

export const GetErrorInfo = (err: any) => {//err is err:obj
  console.log(err);
  if (err.message === "ERR_CANCELED") {
    // DO NOTHING, THIS IS A CANCELLED REQUEST
    return "";
  } else if ((err.message).includes("Network error!")) {
    return "Failed to connect to server.";
  } else if (err.name === "AxiosError") {
    if (err.response.status === 404) return "404 Resource Not Found";
    // else if (err.response.status === 500) return "Internal Server Error";
    else if (err.response.status === 400) return "Invalid request format";
    // else if (err.response.status === 401) return "Unauthorised";
    // else if (err.response.status === 403) return "403 Forbidden";
  } else if (err.name === "TypeError") {
    return `Error: ${err.message}`;
  }
  else if (!err.response || !err.response.data.message) return "Unknown Error.";
  let input = err.response.data.message;
  const regex = /Error:/g;
  let match: RegExpExecArray | null;
  let lastMatchIndex = -1;
  while ((match = regex.exec(input)) !== null) {
    lastMatchIndex = match.index;
  }
  if (lastMatchIndex !== -1) {
    return input.substring(lastMatchIndex + "Error:".length).trim();
  }
  return "Unknown Error";
};

export const GetMemberPortalUrl = (page: "RegisterCpd" | "BecomeMember" | "MemberPayment" | "CpdPayment" | "TrainingCoursePayment" | "OtherPayment", cpdId?: number) => `${memberPortalUrl}?page=${page}${cpdId ? `&cpdId=${cpdId}` : ""}`;

